/**
 * Core types for the Command system
 *
 * Defines the minimal but extensible interface for commands in the CommandPalette
 */

export interface Command {
	/** Unique identifier for the command */
	id: string;

	/** Human-readable title displayed in the palette */
	title: string;

	/** Optional description providing additional context */
	description?: string;

	/** Function to execute when command is invoked */
	action: () => void | Promise<void>;
}

/**
 * Registry interface for command management
 */
export interface CommandRegistryInterface {
	/** Register a new command */
	register(command: Command): void;

	/** Unregister a command by ID */
	unregister(commandId: string): void;

	/** Retrieve all registered commands */
	getAll(): Command[];

	/** Find a command by ID */
	getById(commandId: string): Command | undefined;

	/** Search commands by title/description */
	search(query: string): Command[];
}

/**
 * Error types for command operations
 */
export const CommandError = {
	DUPLICATE_ID: 'DUPLICATE_ID',
	COMMAND_NOT_FOUND: 'COMMAND_NOT_FOUND',
	INVALID_COMMAND: 'INVALID_COMMAND',
} as const;

export type CommandErrorType = keyof typeof CommandError;
